import { FormGroup } from '@angular/forms';
import { ActivatedRoute, Params } from '@angular/router';
import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ControllerForViewBase } from '../../framework/controller-for-view-base';
import { PageContainerService } from '../../../services';
import * as Data from '../../../data';

@Component({
  standalone: false,
  selector: 'create-account',
  templateUrl: './create-account.component.html',
  styleUrls: ['./create-account.component.scss']
})
export class CreateAccountComponent extends ControllerForViewBase implements OnInit {
  createUserCommandRequest: Data.Web.CreateUserCommandRequest = <any>{};
  createUserCommandRequestForm = new FormGroup({});
  createUserCommandRequestFields = Data.Web.CreateUserCommandRequest.FormlyConfig;

  constructor(pcs: PageContainerService, private activatedRoute: ActivatedRoute) {
    super(pcs);
  }

  ngOnInit() {
    this.createUserCommandRequest.Roles = [{ Value: 0, Text: 'Admin' }];
  }

  async createUser() {
    await this.pcs.apiService.CreateUser(this.createUserCommandRequest, undefined, true);
    this.pcs.router.navigate(['login']);
  }
}
